const separatedNumber = (value?: number, option = {} as { symbol?: string, fixed?: number }) => {
  if (isNaN(Number(value))) {
    return value;
  }

  const symbol = option.symbol || ",";
  const fixed = option.fixed || 0;

  const valueNumber = Number(value).toFixed(fixed);
  const valueString = valueNumber.toString();

  return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, symbol);
};

export default separatedNumber;
